module.exports = __webpack_public_path__ + "assets/img/report-act-btn-3.30920c85.png";